<style scoped>
    ::v-deep .v-label {
        font-size: 20px;
    }
</style>
<template>
  <v-row justify="center">
    <v-dialog
      v-model="openDialog"
      :max-width="maxWidth"
      scrollable
    >
      <v-card color="#F4FEFB">
        <v-card-title><slot>タイトル</slot></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-radio-group
            v-if="targetCabinetControl"
            v-model="value"
            column
          >
            <!--
                v-forのkeyやlabelを別変数に入れて指定することはできない模様。 {}で囲っても変数内変数が展開されない？
                ここが指定できる方法がわかれば、汎用componentにできそう
            -->
            <v-radio
                v-for="item in items"
                :key="item.agreements_or_folders_id"
                :label="item.name"
                :value="item.agreements_or_folders_id"
                font
            ></v-radio>
          </v-radio-group>
          <v-radio-group
            v-else
            v-model="value"
            column
          >  
            <v-radio
                v-for="item in items"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                font
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
            <button-component color="blue-grey darken-1" @click="openDialog = false">キャンセル</button-component>
            <button-component :color="okBtnColor" @click="pushOk"><slot name="btnName">OK</slot></button-component>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    data() {
      return {
          value: null,
      }
    },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
        },
        okBtnColor: {
            type: String,
            default: "blue"
        },
        maxWidth: {
            type: String,
            default: "900px",
        },
        // キャビネットとフォルダでkeyが異なってしまっているため判別フラグ
        targetCabinetControl: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        openDialog: {
            get() {
                return this.dialog;
            },
            set(value) {
                this.$emit('update:dialog', value);
            }
        },
    },
    methods: {
        pushOk() {
            this.openDialog = false;
            this.$emit('pushOk', this.value);
        },
    },
  }
</script>